import React from 'react';
import { type LucideProps } from 'lucide-react';

const StoreIcon = (props: LucideProps) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.7409 5.47953L18.212 1.31703C17.986 0.943373 17.5846 0.714355 17.156 0.714355H4.84261C4.41398 0.714355 4.01262 0.943373 3.78662 1.31703L1.25769 5.47953C-0.0476839 7.62909 1.10962 10.6184 3.54892 10.9599C3.72427 10.984 3.90352 10.996 4.08276 10.996C5.23617 10.996 6.25709 10.4737 6.95849 9.66614C7.65988 10.4737 8.42741 10.996 10.9992 10.996C13.9996 11.0001 14.8569 9.66614 14.8569 9.66614C15.5622 10.4737 16.7586 10.996 17.9081 10.996C18.0912 10.996 18.2666 10.984 18.4419 10.9599C20.889 10.6224 22.0502 7.6331 20.7409 5.47953ZM17.9159 12.2858C17.5262 12.2858 17.1404 12.2255 16.7663 12.1331V16.1429H5.23227V12.1331C4.85819 12.2215 4.47243 12.2858 4.08276 12.2858C3.84896 12.2858 3.61127 12.2697 3.38136 12.2376C3.16315 12.2054 2.94884 12.1532 2.74231 12.0929V20.0001C2.74231 20.7112 3.29954 21.2858 3.98924 21.2858H18.0172C18.7069 21.2858 19.2641 20.7112 19.2641 20.0001V12.0929C19.0537 12.1572 18.8433 12.2094 18.625 12.2376C18.3873 12.2697 18.1535 12.2858 17.9159 12.2858Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StoreIcon;
